import React from 'react';
import { VISTA_CONSOLIDADO } from '../utils/currencyView';

const CurrencyViewToggle = ({
  value = VISTA_CONSOLIDADO,
  onChange,
  monedas = [],
  modoOscuro = false,
  className = '',
}) => {
  const options = [
    { id: VISTA_CONSOLIDADO, label: 'Total' },
    ...monedas.map((m) => ({ id: m, label: m })),
  ];

  if (options.length <= 1) return null;

  return (
    <div
      className={`inline-flex items-center rounded-lg border p-0.5 ${
        modoOscuro ? 'border-gray-700 bg-gray-800/80' : 'border-gray-200 bg-gray-50'
      } ${className}`}
      role="group"
      aria-label="Vista de moneda"
    >
      {options.map((opt) => {
        const active = value === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onChange(opt.id);
            }}
            className={`px-2.5 py-1 rounded-md text-[11px] font-semibold transition-colors ${
              active
                ? 'bg-[#1F80FF] text-white'
                : modoOscuro
                  ? 'text-gray-300 hover:text-white'
                  : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default CurrencyViewToggle;
